import {openDigitalCardAfterClose} from '@zzng/common/scheme/digitalcard';

const WebviewTestButton = () => {
  const onClick = () => {
    openDigitalCardAfterClose(location.href);
  };

  return (
    <button className="btn_go_webview" onClick={onClick}>
      <span className="icon icon_go_webview">로컬&샌박환경에서 웹뷰이동</span>
    </button>
  );
};
export default WebviewTestButton;
